module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors/img_main-4edde5685f35a485a8a21acd1580ce63.jpg";